import { keepTruthy } from "./array.utils";

export default function joinClassName(...arg: (string | boolean | number | null | undefined)[]) {
  if (arg.length === 1) return arg[0] ? '' + arg[0] : undefined;
  return keepTruthy(arg).join(' ');
}